export default "__VITE_ASSET__CCat8wa$__"